var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconConcise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2275 4.40625H3.85254C3.74941 4.40625 3.66504 4.49062 3.66504 4.59375V6.09375C3.66504 6.19687 3.74941 6.28125 3.85254 6.28125H22.2275C22.3307 6.28125 22.415 6.19687 22.415 6.09375V4.59375C22.415 4.49062 22.3307 4.40625 22.2275 4.40625ZM22.2275 11.7188H3.85254C3.74941 11.7188 3.66504 11.8031 3.66504 11.9062V13.4062C3.66504 13.5094 3.74941 13.5938 3.85254 13.5938H22.2275C22.3307 13.5938 22.415 13.5094 22.415 13.4062V11.9062C22.415 11.8031 22.3307 11.7188 22.2275 11.7188Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConcise);
export default __webpack_public_path__ + "static/media/IconConcise.81eb21842c27213afc483d3f4fd5d266.svg";
export { ForwardRef as ReactComponent };